<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', tipoicms)">
      <v-card v-if="tipoIcms" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} TipoICMS </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="tipoIcms.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="tipoIcms.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(tipoIcms)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import TipoICMS from '../../models/tipoicms'
import TipoICMSService from '../../services/tipoicms/tipoicms'
import { obrigatorio } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'tipoIcmsParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    tipoIcms: new TipoICMS(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    menuDataInicio: false,
    menuDataFim: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    tipoIcmsParam() {
      return this.tipoIcmsParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.tipoIcms = new TipoICMS()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.tipoIcms = this.tipoIcmsParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const tipoICMSSalva =
          this.operacao === 'adicionar'
            ? await TipoICMSService.create({ ...data })
            : await TipoICMSService.update(data.id, data)

        this.$emit('confirmado', tipoICMSSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
